export default __webpack_public_path__ + "static/media/sales-marketing.60f9b262.svg";